module.exports = __webpack_public_path__ + "img/blog.d6a55fbf.png";